module.exports = "pegasus/assets/themelp1/travel/102.png";